import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RollingIntoYourNeighborhood from "./sections/RollingIntoYourNeighborhood";
import TodaySPitStop from "./sections/TodaySPitStop";
import TheTacoLineup from "./sections/TheTacoLineup";
import StreetCred from "./sections/StreetCred";
import FreshnessOnWheels from "./sections/FreshnessOnWheels";
import JoinTheTacoTribe from "./sections/JoinTheTacoTribe";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RollingIntoYourNeighborhood />
      <TodaySPitStop />
      <TheTacoLineup />
      <StreetCred />
      <FreshnessOnWheels />
      <JoinTheTacoTribe />
      <Footer />
    </div>;
}